import React, { Component } from "react";
import moment from "moment";

import {
  Card,
  CardBody,
  Title,
  Wrapper,
  Copy
} from "app/NativeComponents/common";

import { SmallLabel } from "app/NativeComponents/snippets";

import { renderPrice } from "app/NativeActions";

class MarketingCreditCharges extends Component {
  render() {
    if (!this.props.start_date && !this.props.end_date) {
      return (
        <Wrapper
          style={{
            padding: 25,
            margin: 5,
            borderRadius: 5,
            backgroundColor: this.props.colors.active_color_muted
          }}
        >
          <SmallLabel style={{ padding: 0, paddingTop: 0, paddingBottom: 0 }}>
            Lifetime Marketing Investment
          </SmallLabel>
          <Title>{renderPrice(this.props.total_spent)}</Title>
        </Wrapper>
      );
    }

    return (
      <Wrapper
        style={{
          padding: 25,
          margin: 5,
          borderRadius: 5,
          backgroundColor: this.props.colors.active_color_muted
        }}
      >
        <SmallLabel style={{ padding: 0, paddingTop: 0, paddingBottom: 0 }}>
          {"Marketing investments from " +
            moment(this.props.start_date).format("MMM Do, YYYY") +
            " to " +
            moment(this.props.end_date).format("MMM Do, YYYY")}
        </SmallLabel>
        <Title>{renderPrice(this.props.total_spent)}</Title>
      </Wrapper>
    );
  }
}

export default MarketingCreditCharges;
